import moment from "moment";
import pdfMake from "../pdfmakeWrapper";

const PdfReportSavingsCollection = ({
  collectionData,
  totalSummary,
  tenureType,
  paidStatus,
  startDateD,
  endDateD,
}) => {
  const filterSection = [
    { text: "Savings Collection Report", style: "title" },
    {
      text: `Date Range: ${moment(startDateD).format("DD/MM/YYYY")} - ${moment(endDateD).format("DD/MM/YYYY")}`,
      style: "filter",
    },
    { text: `Tenure: ${tenureType}`, style: "filter" },
    { text: `Status: ${paidStatus}`, style: "filter", margin: [0, 0, 0, 20] },
  ].map((item) => ({ ...item, alignment: "center" }));

  const fourBlockData = [
    { heading: "Collected", value: totalSummary?.collectedAmount ?? 0 },
    { heading: "Target", value: totalSummary?.targetAmount ?? 0 },
    { heading: "Overdue Amount", value: totalSummary?.overdueAmount ?? 0 },
    { heading: "Penalty", value: totalSummary?.totalPenalty ?? 0 },
  ];

  const fourBlockRow = {
    table: {
      widths: ["25%", "25%", "25%", "25%"],
      body: [
        fourBlockData.map((item) => ({
          stack: [
            { text: item.heading, style: "fourBlockHeading" },
            { text: item.value, style: "fourBlockValue" },
          ],
          alignment: "center",
          style: "fourBlock",
        })),
      ],
    },
    layout: { hLineWidth: () => 1, vLineWidth: () => 1 },
    margin: [0, 0, 0, 10],
  };

  const tableHeaders = [
    "Sr. No.",
    "Customer",
    "Saving ID",
    "Collection Agent",
    "Total Amount",
    "Installment",
    "Collection Amount",
    "Due Date",
    "Collected Date",
    "Seq",
    "Penalty",
    "Status",
  ];

  const tableBody = [
    tableHeaders.map((header) => ({
      text: header,
      style: "tableHeader",
      alignment: "center",
    })),
    ...collectionData.map((data, index) => {
      const customerName = `${data?.customer?.firstName ?? ""} ${data?.customer?.lastName ?? ""}`.trim();
      const custId = data?.customer?.cust_id ? ` (${data.customer.cust_id})` : "";
      const agentName = data?.user ? `${data.user.firstName} ${data.user.lastName}` : "";

      return [
        index + 1,
        customerName + custId,
        data?.saving?.savingCode,
        agentName,
        data?.saving?.totalAmount,
        data?.Installment,
        data?.collectionAmount,
        data?.dueDate ? moment(data.dueDate).format("DD/MM/YYYY") : "",
        data?.collectedDate ? moment(data.collectedDate).format("DD/MM/YYYY") : "",
        data?.saving?.tenureType,
        data?.penaltyApplied,
        data?.saving?.savingStatus,
      ];
    }),
  ];

  const docDefinition = {
    pageOrientation: "landscape",
    content: [
      ...filterSection,
      fourBlockRow,
      {
        table: {
          headerRows: 1,
          widths: ["auto", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
          body: tableBody,
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? "#f0f0f0" : null),
        },
        dontBreakRows: false,
      },
    ],
    styles: {
      title: { fontSize: 16, bold: true, marginBottom: 10 },
      filter: { fontSize: 10, marginBottom: 2 },
      tableHeader: { fontSize: 9, bold: true },
      fourBlockHeading: { fontSize: 11, bold: true, margin: [0, 5, 0, 2] },
      fourBlockValue: { fontSize: 10, margin: [0, 2, 0, 5] },
      fourBlock: { margin: [0, 5, 0, 5] },
    },
    defaultStyle: { alignment: "center", fontSize: 8 },
    pageMargins: [10, 10, 10, 10],
  };

  pdfMake.createPdf(docDefinition).download("SavingsCollectionReport.pdf");
};

export default PdfReportSavingsCollection;